// Constants measured from the original Game Boy game (see docs/REVERSE_ENGINEERING.md).

/** Game Boy frame rate. */
export const FPS = 59.7275;
/** The original runs its physics at a "tick" every 5.7158 video frames (~10.45 Hz). */
export const TICK_FRAMES = 5.7158;
export const FRAME_PER_TICK = 1 / TICK_FRAMES;

/** Lateral position: road centre and limits (units of the original). */
export const LAT_CENTER = 128;
export const LAT_START = 144; // grid slot used by the player in the original
export const ROAD_HALF = 48; // free driving
export const WALL_DIST = 57; // |lat-128| beyond this: barrier contact
export const LAT_CLAMP = 65;
/** |lat-128| beyond this: the wheels run on the rumble strips (sound in the game; the animator counts the distance). */
export const KERB_LAT = 40;

/** Playfield geometry in the 160x144 internal resolution. */
export const SCREEN_W = 160;
export const SCREEN_H = 144;
export const HORIZON_Y = 40;
export const ROAD_ROWS = 48; // rows 0..47 -> y = 40..87
export const CAR_ROW = 34; // row where the player's wheels touch the road
export const HUD_Y = 88;

/** Perspective: z(i) = KZ * (1/(i+I0) - 1/(CAR_ROW+I0)), z(0) = DRAW_DIST. */
export const I0 = 18;
export const DRAW_DIST = 14750; // track units visible ahead (~1.04 s at 280 km/h)

/** One circuit lap of the first course is 655360 internal units. */
export const UNIT_PER_TICK_FACTOR = 5; // position += 5 * (speed & 0xFFF0) per tick
export const SPEED_QUANT = 16;

export const MAX_PLAYERS = 8; // the original multi-game stopped at 4 (DMG-07 adapter); the grid holds 10 cars, the lobby screen 8 names
export const GRID_SIZE = 10;

/** Circuits with hillPhysics: km/h lost per pixel of climb (and gained per pixel of descent) of the road under the car. */
export const HILL_GRAVITY = 7;
/** A descent can push the car at most this far (km/h) above the machine's jet top speed. */
export const HILL_OVERSPEED = 25;
